import {
  Box,
  Button,
  SxProps,
  Theme,
  useMediaQuery,
  useTheme,
} from '@mui/material';
import React from 'react';

const buttonSx = (theme: Theme) => ({
  padding: theme.spacing(1),
  [theme.breakpoints.down('sm')]: {
    boxShadow: 'none',
  },
  // Outer button Container
  [theme.breakpoints.down('sm')]: {
    minWidth: theme.spacing(4),
    height: theme.spacing(4),
    width: theme.spacing(4),
  },
  minWidth: theme.spacing(4.5),
  height: theme.spacing(4.5),
  width: theme.spacing(4.5),

  // Fonts
  ...theme.typography.subtitle2,
  [theme.breakpoints.up('xs')]: {
    ...theme.typography.subtitle1,
  },
  // Icon
  '& svg': {
    display: 'block',
    fontSize: 'large',
  },
  '&:hover': {
    color: theme.palette.action.active,
  },
});

const subMenuItemButtonSx = (theme: Theme) => ({
  display: 'flex',
  alignItems: 'center',
  '& button': {
    boxShadow: 'none',
    maxHeight: theme.spacing(5),
    textTransform: 'capitalize',
  },
  '& button:hover': {
    backgroundColor: 'transparent',
  },
});

interface NavButtonProps {
  anchorRef: React.RefObject<HTMLButtonElement>;
  setIsModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  isModalOpen: boolean;
  buttonStyle?: SxProps<Theme>;
  componentName?: string;
  icon: React.ReactNode;
  disabled?: boolean;
  // handleClick?: React.SyntheticEvent;
}
interface StyledButtonContentProps {
  componentName?: string;
  icon?: React.ReactNode;
}
const StyledButtonContent: React.FC<React.PropsWithChildren<StyledButtonContentProps>> = (props) => {
  const { componentName, icon } = props;
  const theme = useTheme();

  const mobileSize = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <Box sx={subMenuItemButtonSx} title={componentName}>
      {mobileSize ? <Box component="span">{icon}</Box> : icon}
    </Box>
  );
};
const NavButton = (props: NavButtonProps) => {
  const {
    anchorRef,
    isModalOpen,
    setIsModalOpen,
    buttonStyle,
    componentName,
    icon,
    disabled,
  } = props;

  const handleNavButtonClick = () => {
    setIsModalOpen(!isModalOpen);
  };

  return (
    <Button
      data-testid="nav-item-button"
      ref={anchorRef}
      aria-controls={isModalOpen ? 'menu-list-grow' : undefined}
      aria-haspopup="true"
      onClick={() => handleNavButtonClick()}
      sx={[
        buttonSx,
        ...(Array.isArray(buttonStyle) ? buttonStyle : [buttonStyle]),
      ]}
      disabled={disabled}
    >
      <StyledButtonContent componentName={componentName} icon={icon} />
    </Button>
  );
};

export default NavButton;
